"use strict";

module.exports = {
    "search2": {
        "search-button-text": "Найти",
        "search-input-label": "Запрос",
        "search-service-label": "Поиск по сервису",
        "search-web-label": "Поиск в интернете"
    }
};